// Determine the API base URL based on environment
const getApiBaseUrl = () => {
    // If running in ThinkBeyond environment
    if (window.location.hostname === 'bf.thinkbeyond.ai') {
        return 'https://bf.thinkbeyond.ai/api/v1';
    }
    
    // For local development
    const API_PORT = process.env.REACT_APP_API_PORT || '5000';
    return `http://localhost:${API_PORT}/api/v1`;
};

const API_BASE_URL = getApiBaseUrl();

export const API_ENDPOINTS = {
    BASE: API_BASE_URL,
    VERSION: `${API_BASE_URL}/version`,
    HEALTH: `${API_BASE_URL}/health`,
    PING: `${API_BASE_URL}/ping`,
    TEST: `${API_BASE_URL}/test`,
    UPLOAD_PROCESS: `${API_BASE_URL}/upload-process`,
    UPLOAD_CORRECTIONS: `${API_BASE_URL}/upload-corrections`,
    PROCESSING_STATUS: `${API_BASE_URL}/processing-status`,
    FEEDBACK: `${API_BASE_URL}/feedback`,
    ACCURACY_STATS: `${API_BASE_URL}/accuracy-stats`,
    DOWNLOAD_PREDICTIONS: `${API_BASE_URL}/download-predictions`,
    DOWNLOAD_EXCEL: `${API_BASE_URL}/download-predictions`,
    HISTORY: `${API_BASE_URL}/history`,
    DATABASE_SETUP: `${API_BASE_URL}/database/setup`,
};

// Supabase configuration
export const SUPABASE_CONFIG = {
    URL: process.env.REACT_APP_SUPABASE_URL || '',
    ANON_KEY: process.env.REACT_APP_SUPABASE_KEY || '',
};

export default {
    API_BASE_URL,
    API_ENDPOINTS,
    SUPABASE_CONFIG,
}; 